import React, { Component } from 'react'
import Icon, { IconColor } from './Icon'

type CheckboxStateName = 'checked' | 'unchecked'
type CheckboxStates = Record<CheckboxStateName, CheckboxState>
type CheckboxAlign = 'start' | 'center' | 'end'
type CheckboxAlignClasses = Record<CheckboxAlign, string>

interface CheckboxProps {
  name: string
  label?: string
  checked: boolean
  align?: CheckboxAlign
  onChange: (name: string) => void
  className?: string
}

interface CheckboxState {
  icon: string
  color: IconColor
}

export default class Checkbox extends Component<CheckboxProps> {
  static defaultProps = {
    align: 'end'
  }

  states: CheckboxStates = {
    checked: {
      icon: 'checkbox',
      color: 'dark'
    },
    unchecked: {
      icon: 'checkbox-blank',
      color: 'light'
    }
  }

  alignClasses: CheckboxAlignClasses = {
    start: 'items-start mt-2',
    center: 'mt-0 md:mt-5 mb-3',
    end: 'items-end mb-3'
  }

  constructor (props: CheckboxProps) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  get className () {
    const { align, className } = this.props
    const base = 'flex cursor-pointer'
    const alignClass = align && this.alignClasses[align]
    return `${base} ${alignClass} ${className}`
  }

  get check () {
    return this.props.checked
      ? this.states.checked
      : this.states.unchecked
  }

  get label () {
    const { label } = this.props
    return label &&
      <div className="ml-2">{label}</div>
  }

  handleClick () {
    this.props.onChange(this.props.name)
  }

  render () {
    return (
      <div className={this.className}>
        <div
          className="flex items-center"
          onClick={this.handleClick}>
          <Icon
            name={this.check.icon}
            size="large"
            color={this.check.color} />
          {this.label}
        </div>
      </div>
    )
  }
}
